// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SketchSquareFilledSvg from "@fishx/icons-svg/es/asn/SketchSquareFilled";
import FishxIcon from '../components/FishxIcon';

var SketchSquareFilled = function SketchSquareFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SketchSquareFilledSvg
  }));
};

SketchSquareFilled.displayName = 'SketchSquareFilled';
export default React.forwardRef(SketchSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SketchSquareFilled.js
// module id = 4123
// module chunks = 0